import httpClient from "../../http-client"

const uploadFile = async (formData: FormData) => {
  return (await httpClient.post('/files', formData)).data;
}

export {
  uploadFile
}